import { humanizeTimestamp } from '~/utils/date-helper';
import titleMap from '~/components/Transaction/data/title.json';
import { jsonToBase64Url } from '~/utils/base64-utils';

/**
 * Craft transaction object to be used in Mitra Chat feature from the selected Buka 2.0 Mitra transaction
 */
export const createFromBuka20MitraTrx = trx => {
  const { detail, created_at: createdAt } = trx;

  return {
    productType: titleMap[detail.transaction_type],
    createdTime: humanizeTimestamp(createdAt, '%dd% %mmm% %yyyy% - %hh%:%mi% WIB'),
    paymentId: detail.invoice_group_number,
    status: detail.status,
    paymentMethod: detail.payment_type === 'dana' ? 'Dana' : 'Saldo',
    trxType: detail.transaction_type,
    detailId: detail.transaction_id,
  };
};

/**
 * Craft transaction object to be used in Mitra Chat feature from the selected legacy Mitra transaction
 */
export const createFromLegacyMitraTrx = trx => {
  const { detail, created_at: createdAt } = trx;
  const trxType = detail.transactions?.[0]?.type || detail.type || detail.transaction_type || trx.trx_type;
  const titleData = titleMap;
  return {
    productType: titleData[trxType] || detail.description || detail.action,
    createdTime: humanizeTimestamp(createdAt, '%dd% %mmm% %yyyy% - %hh%:%mi% WIB'),
    paymentId: detail.payment_id || detail.invoice_id || detail.invoice_group_number,
    status:
      detail.transactions?.[0]?.detail?.state ||
      detail?.transaction_group_details?.[0]?.state ||
      detail.state ||
      detail.status,
    paymentMethod: detail.payment_type === 'dana' ? 'Dana' : 'Saldo',
    trxType: trx.trx_type === 'invoices' ? detail.transactions?.[0]?.type : trx.trx_type,
    detailId: detail.id || detail.transaction_id,
  };
};

/**
 * This function is responsible for crafting transaction payload that would be used in the entire Mitra Chat feature
 * The value returned by this function should be assigned to the `chat` query parameter
 * Use this in these components:
 * - pages/Guide/Transaction.vue
 * - pages/Lite/Transaksi/Details/generic.vue
 *
 * @returns {string} - base64 transaction object, converted with jsonToBase64Url()
 */
export const createMitraChatTrxQueryParam = trx => {
  const trxType = trx.trx_type;

  if (trxType === 'buka20-transactions') {
    const result = createFromBuka20MitraTrx(trx);
    return jsonToBase64Url(result);
  }

  const result = createFromLegacyMitraTrx(trx);
  return jsonToBase64Url(result);
};
